import { Navigate } from 'react-router-dom'

export default function ExternalPrestadorRedirect({ subpath }: { subpath?: string }) {
  const url = `https://prestador.tamoaki.co.ao/${subpath ? subpath : ''}`
  if (typeof window !== 'undefined') {
    window.location.replace(url)
  }
  return <Navigate to={url} replace />
}

